import { render, staticRenderFns } from "./ConfirmPasswordDialog.vue?vue&type=template&id=60c98c8e&scoped=true&"
import script from "./ConfirmPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmPasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPasswordDialog.vue?vue&type=style&index=0&id=60c98c8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c98c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
